<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          title="Doctor Appointment Schedule List"
          btnTitle="Add New"
          :showBtn="false"
          :showAddNew="false"
          :showExtraBtn="true"
          extraBtnTitle="Calendar View"
          @onClickExtraBtn="navigateToListPage"
      />
    </div>
    <div class="my-2 px-2">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="colFormLabel" class="col-form-label">Date</label>
            <input
                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                tabindex="1"
                type="date"
                placeholder=""
                v-model="endDate"
            >
          </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Doctor</label>
          <AsyncSelect
              placeholder="Select Doctor"
              v-model="contactProfileId"
              :api-service="fetchContactProfiles"
              :additional-query="{ roles: 'doctor,medical_officer', status: 'active' }"
              label="name"
              :reduce="name => name.id"
          />
        </div>
          <div class="col-sm-2 col-md-2 d-flex align-items-end mt-2 action-btn-setter">
            <button
                style="min-width: 64px;"
                @click="onClickToGo"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Go
            </button>
          </div>
        </div>
    </div>

    <div class="px-2">
    <div class="col-12">
      <div class="card shadow-sm border-0">
        <div class="card-body" style="min-height: 300px">
          <div class="table-responsive border rounded">
            <table class="table table-bordered align-middle text-center no-hover mb-0">
            <thead class="table-light">
              <tr>
                <th>#SL</th>
                <th>Doctor Details</th>
                <th>Schedule</th>
              </tr>
              </thead>

              <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td>{{ i+1 }}</td>
                  <td>
                    {{ item.name }} ({{ item.serial_no }})
                  </td>
                  <td>
                    {{ item.title }}
                  </td>
                </tr>
                <tr v-if="tableItems.length < 1">
                  <td colspan="3">No Data Found!</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <div class="px-2 position-absolute bottom-0 mt-4">
      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>

    <Loader v-if="loading"/>
    </div>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleDropdowns from "@/services/modules/dropdowns";
import Pagination from '@/components/atom/Pagination'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const contactProfileId = ref('');
const endDate = ref('');
const params = ref({
  offset: 20,
});
const token = computed(() => localStorage.getItem('token'));

const {
  fetchDoctorAppointmentScheduleList
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

function navigateToListPage() {
  router.push({name: `doctors-appointment-schedule`, params: route.params, query: route.query});
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getDoctorSchedule();
}

const onClickToGo = () => {
  getDoctorSchedule();
}

const getDoctorSchedule = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []

  await fetchDoctorAppointmentScheduleList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }
    tableItems.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&end_date=' + endDate.value;
  query += '&offset=' + params.value.offset;
  if (contactProfileId.value) query +=  '&contact_profile_id=' + contactProfileId.value
  if (route.query.page) query += '&page=' + route.query.page;
  return query;
}

onMounted(() => {
  endDate.value = new Date().toISOString().split('T')[0]
  Promise.all([
    getDoctorSchedule()
  ])
})

</script>

<style scoped>
</style>